import {
  FullScreenMessage,
  InAppMessageButton,
  ModalMessage,
} from "@braze/web-sdk";
import { parseMarkdownEvent } from "@origin-digital/event-dispatcher";

import { BUTTON_CLICK_ACTION_NONE } from "../utils/config";
import { shouldUseEventDispatch } from "../utils/events";

// add an action for all IAM buttons to handle navTo or navClose
export const overwriteButtonAction = (
  inAppMessage: ModalMessage | FullScreenMessage
) => {
  const { buttons } = inAppMessage;
  const btnsInDom = document.querySelectorAll(".ab-message-button");

  if (!btnsInDom.length) {
    return;
  }

  return buttons.forEach((button, i) => {
    if (button.uri && shouldUseEventDispatch(button.uri)) {
      const { onClick } = parseMarkdownEvent(button.uri);
      if (onClick) {
        btnsInDom[i].addEventListener("click", () => onClick());
      }
    }
  });
};

// if the URI contains navTo or navClose - reset the action to "NONE"
export const configureButtons = (
  buttons: InAppMessageButton[]
): InAppMessageButton[] => {
  buttons.forEach((button: InAppMessageButton) => {
    if (button.uri && shouldUseEventDispatch(button.uri)) {
      button.clickAction = BUTTON_CLICK_ACTION_NONE;
    }
  });
  return buttons;
};
